<template>
  <div>
    <div class="mb-2 font-bold text-sm">Kriteria transfer stok :</div>
    <div>
      <ul class="stock-rule-list">
        <li>Perpindahan stok dari satu gudang ke gudang lain</li>
        <li>Transfer stok tidak mengurangi stok kumulatif hanya mengurangi stok di gudang tertentu saja</li>
      </ul>
    </div>
  </div>
</template>